import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../public/img/ZBEdge-lightbg.svg'
import _imports_1 from '../../public/img/Zimmer-Biomet-logo.svg'


const _hoisted_1 = { class: "max-page-width-nav container navbar navbar-expand-sm navbar-toggleable-sm navbar-light" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  key: 1,
  src: _imports_1
}
const _hoisted_4 = { class: "navbar-nav flex-grow-1" }
const _hoisted_5 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_6 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_7 = {
  key: 2,
  class: "nav-item dividerWrap"
}
const _hoisted_8 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 4,
  class: "nav-item"
}
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          id: "logoWrap",
          class: "navbar-brand",
          to: _ctx.isApp == false ? {name:'Dashboard'} : {}
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1)
          ]))]),
          _: 1
        }, 8, ["to"]),
        (_ctx.IsLoggedIn)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.collapsed=!_ctx.collapsed)),
              class: "navbar-toggler",
              type: "button",
              "aria-controls": "navbarSupportedContent",
              "aria-expanded": "false",
              "aria-label": "Toggle navigation"
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        (!_ctx.IsLoggedIn)
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.authenticationRequired == false)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass([{ collapse: _ctx.collapsed }, "navbar-collapse d-sm-inline-flex justify-content-between"])
            }, [
              _createElementVNode("ul", _hoisted_4, [
                (_ctx.IsLoggedIn && _ctx.CanBulkLoad)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                      _createVNode(_component_router_link, {
                        class: "nav-link text-dark",
                        to: {name:'InviteBulkLoad'}
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode(" Bulk Load Invites ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.IsLoggedIn)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                      _createVNode(_component_router_link, {
                        class: "nav-link text-dark",
                        to: {name:'EditProfilePage'}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.FullName), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.IsLoggedIn)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_7, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("div", { class: "header-hr text-dark" }, " | ", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (_ctx.IsLoggedIn)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                      _createElementVNode("a", {
                        class: "nav-link text-dark",
                        href: _ctx.FixProxyAuthUrl('/logout')
                      }, _toDisplayString(_ctx.$t('sign_out')), 9, _hoisted_9)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.IsLoggedIn && _ctx.authenticationRequired == false)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                      _createElementVNode("a", {
                        class: "nav-link text-dark",
                        href: _ctx.FixProxyAuthUrl('/login')
                      }, _toDisplayString(_ctx.$t('sign_in')), 9, _hoisted_11)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}